import { UserRole } from "tm-shared/types";

export const MANAGER_AGENT_VOCABULARY = {
    [UserRole.Sv]: UserRole.Ta,
    [UserRole.Svm]: UserRole.Md,
};
